export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SECONDS = 10;
export const RES_PER_PAGE = 15;
export const KEY = '922614f3-dfbb-4a67-9297-0f32b680b817';
export const MODAL_CLOSE_SECONDS = 2.5;
